import {
  AnyAction,
  isAsyncThunkAction,
  isFulfilled,
  isPending,
  isRejected,
  isRejectedWithValue,
  Middleware,
} from '@reduxjs/toolkit';

import { loaderActions } from 'store/state/slices';

const IGNORED_ENDPOINTS = [
  'getOfferFilters',
  'getFilteredOffers',
  'getBalance',
  'getDirectedOffersCount',
  'getMyOffersCount',
  'getSummaryCart',
  'getUserWithCustomers',
  'getProductsBasedOnLastVisit',
  'getProductsMostSearched',
];

const requests: string[] = [];
export const loaderMiddleware: Middleware =
  () => (next) => (action: AnyAction) => {
    if (isAsyncThunkAction(action)) {
      if (action.meta.arg) {
        const args = action.meta.arg as any;
        if (IGNORED_ENDPOINTS.includes(args.endpointName)) {
          return next(action);
        }
      }
      if (isPending(action)) {
        requests.push(action.meta.requestId);
        next(loaderActions.show());
      } else if (
        isFulfilled(action) ||
        isRejected(action) ||
        isRejectedWithValue(action)
      ) {
        const index = requests.findIndex((id) => id === action.meta.requestId);
        if (index >= 0) {
          requests.splice(index, 1);
        }
      }

      if (!requests.length) {
        next(loaderActions.hide());
      }
    }

    return next(action);
  };
